import { useRouter } from "next/router";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { portalRoutes } from "@nju/routes";
import { BlockContent, GeneralErrorNotification, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function NoPesel() {
  const router = useRouter();

  return (
    <LayoutWrapper>
      <Header />
      <ClientSideOnly>
        <BlockContent grid="default" spacing="xl" tone="none">
          <GeneralErrorNotification
            callback={() => {
              router.replace(portalRoutes.mojeKonto.index.get());
            }}
            copy="powrót"
            description="Z usługi nju abonament mogą korzystać tylko osoby pełnoletnie. Umowę może zawrzeć np. rodzic, opiekun lub pełnoletnie rodzeństwo."
            icon="times-circle"
            title="masz mniej niż 18 lat"
          />
        </BlockContent>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
